<template>
	<!-- 系统目录 西成药品 -->
	<div class="MedicenCata">
		<!--  描述  -->
		<div class="header">
			<div class="header-icon">
				<i class="el-icon-charging"
					style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;background-color: #409EFF;color: #fff;"></i>
				<span style="font-size: 12px;font-weight:400;margin-left: 12px;">客户档案</span>
			</div>
		</div>
		<!-- main -->
		<div class="main">
			<!-- left -->
			<div class="main-left">
				<!-- tree -->
				<el-tree 
				:data="elTree" 
				v-loading="loading"
				element-loading-spinner="el-icon-more-outline"
				:props="defaultProps"
				node-key="label"
				:default-expanded-keys="['全部']"
				accordion 
				@node-click="handleNodeClick"
				class="custom-tree"
				>
					<span class="custom-tree-node" slot-scope="{ node, data }" style="font-size: 12px;">
						<span :name="node.label">
							<i v-if="!data.children"
							:class="node.expanded ? 'el-icon-openFile' : 'el-icon-closeFiles'"></i>
							<i v-else class="el-icon-openFile"></i>{{ node.label }}
						</span>
					</span>
				</el-tree>
			</div>
			<!-- right -->
			<div class="main-right" ref="mainRight">
				<!-- tit -->
				<div class="main-icon">
					<div class="main-icon-a">
						<i :class="iconComes" style="border-radius: 50%;font-size: 20px;padding: 6px;margin-left: 8px;;background-color: #5a5a5a;color: #fff;"></i>
						<span style="font-size: 12px;font-weight:bold;margin-left: 12px;color: #606266;">{{ CatalogueName }}</span>
					</div>
					<!-- btn1 -->
					<div class="main-icon-b">
						<span style="font-size: 12px;color: #606266;font-weight: bold;">状态：</span>
						<el-dropdown @command="handleCommand" trigger="click">
							<span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
							<el-dropdown-menu slot="dropdown">
							  <el-dropdown-item command="a">可用</el-dropdown-item>
							  <el-dropdown-item command="b">禁用</el-dropdown-item>
							  <el-dropdown-item command="c" divided>全部</el-dropdown-item>
							</el-dropdown-menu>
					    </el-dropdown>
					</div>
					<!-- btn2 -->
					<div class="main-icon-c">
						<span style="font-size: 12px;color: #606266;font-weight: bold;display: inline-block;width: 68px;">关键字：</span>
						<el-input size="mini" placeholder="编码、名称、拼音简码" suffix-icon="el-icon-key" v-model="searchValue"></el-input>
					</div>
					<!-- btn3 -->
					<div class="main-icon-c">
						<el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon" size="mini" @click="handClick(i)">{{ v.title }}</el-button>
					</div>
				</div>
				<!-- table -->
				<div class="table">
					<el-table :data="tableData" border @row-dblclick="handledbRow" :style="{ width: windowWidth + 'px' }"
					 element-loading-text="查询中" v-loading="loading" element-loading-spinner="el-icon-more-outline">
						<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"></el-table-column>
						<!-- fixed -->
						<el-table-column fixed="left" label="行号" type="index"></el-table-column>
						<!-- edit -->
						<el-table-column fixed="right" label="操作" width="148">
						      <template slot-scope="scope">
								  <div class="editbox" style="text-align: center;">
									<el-button type="primary" @click="handleClickEdit(scope.row)" size="mini">编辑</el-button>
									<el-button type="danger" @click="handleDelete(scope.row.id)" size="mini">删除</el-button>
								  </div>
						      </template>
						</el-table-column>
					</el-table>
				</div>
				<!-- 分页 -->
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="pageNum"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				:total="totalSize"
				layout="total, sizes, prev, pager, next, jumper"
				background
				>
				</el-pagination>
			</div>
		</div>
		<!-- feet -->
		<div class="feet">
			<!-- add data 新增 -->
			<!-- messagesBox -->
			<div class="addmessagesBox">
				<el-dialog  title="新增" :visible.sync="addChargingVisible" width="66%" :before-close="handleClose">
				<div class="aform">
					<!-- 表单 -->
					<el-form ref="form" :model="addForm" label-width="88px" size="mini">
						<el-row :gutter="20">
						  <el-col :span="v.spanRows" type="flex" v-for="(v,i) in formType" :key="i">
							  <!-- input -->
							  <el-form-item v-if="v.type == 'input'" :label="v.label">
								<el-input :suffix-icon='v.prefix' v-model="$data.addForm[v.modelValue]" :placeholder="v.placeholder" @blur='OpenIconsFocus(v,i)'></el-input>
							  </el-form-item>
							  <!-- select -->
							  <el-form-item v-if="v.type == 'select'" :label="v.label">
								<el-select v-model="$data.addForm[v.modelValue]" filterable :placeholder="v.placeholder" @focus="sname(v,i)" @change="scname">
									<el-option v-for="item in $data[v.op]" :key="item.pe" :label="item.label" :value="item" filterable> 
									<span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
								</el-select>
							  </el-form-item>
							  <!-- input -->
							  <el-form-item v-if="v.type == 'textarea'" :label="v.label">
								<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="$data.addForm[v.modelValue]"></el-input>
							  </el-form-item>
						  </el-col>
						</el-row>
					</el-form>
				</div>	
				  <span slot="footer" class="dialog-footer">
				    <el-button type="primary" @click="addNewData" size="mini">确 定</el-button>
				    <el-button @click="addMenuDialog = false" size="mini">取 消</el-button>
				  </span>
				</el-dialog>
			</div>
			<!-- messagesBox -->
			<div class="editmessagesBox">
				<el-dialog  title="编辑" :visible.sync="editChargingVisible" width="66%" :before-close="handleClose">
				<div class="aform">
					<!-- 表单 -->
					<el-form ref="form" :model="editForm" label-width="88px" size="mini">
						<el-row :gutter="20">
						  <el-col :span="v.spanRows" type="flex" v-for="(v,i) in editType" :key="i">
							  <!-- input -->
							  <el-form-item v-if="v.type == 'input'" :label="v.label">
								<el-input :suffix-icon='v.prefix' v-model="$data.editForm[v.modelValue]" :placeholder="v.placeholder" @blur='OpenIconsFocus(v,i)'></el-input>
							  </el-form-item>
							  <!-- select -->
							  <el-form-item v-if="v.type == 'select'" :label="v.label">
								<el-select v-model="$data.editForm[v.modelValue]" filterable :placeholder="v.placeholder" @focus="sname(v,i)" @change="scname">
									<el-option v-for="item in $data[v.op]" :key="item.pe" :label="item.label" :value="item" filterable> 
									<span style="float: center; color: #8492a6; font-size: 12px">{{ item.label }}</span></el-option>
								</el-select>
							  </el-form-item>
							  <!-- input -->
							  <el-form-item v-if="v.type == 'textarea'" :label="v.label">
								<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="$data.editForm[v.modelValue]"></el-input>
							  </el-form-item> 
						  </el-col>
						</el-row>
					</el-form>
				</div>	
				  <span slot="footer" class="dialog-footer">
				    <el-button type="primary" @click="saveEditData" size="mini">修 改</el-button>
				    <el-button @click="editChargingVisible = false" size="mini">取 消</el-button>
				  </span>
				</el-dialog>
			</div>
		</div>

	</div>
</template>/

<script>
	// selfs / js
	import Chinese from "@/external/PY.js";
	import Pinyin from "@/external/pinyin.js";

	// 接口
	import { getCostType,getMREC,getSosTypes,
			addChargeProject,standardList,getCostList,updateChargeProject,	
		} from "@/api/Outpatient/category.js";
	export default {
		components: {
			// MedicenCata
		},
		data() {
			return {
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				// str
				tableWidth:'', //右侧表格动态宽度
				windowWidth:'',
				watch:'查看',
				searchValue:'',
				toCodeNum:'0000',//拼接自增 导零
				iconHandleClick:'el-icon-charging',
				CatalogueName:'',
				DropDownedName:'可用',
				typeValue:'',
				YNuseVaule:'可用',
				nowDateTimeValue:'',
				iconComes:'el-icon-charging',
				operatingTime:'',
				// boolean
				disabled:true,
				noEidt:true,
				formdisabled:true,
				loading:false,
				dialogVisible:false,	//此乃查看/编辑控制
				addChargingVisible: false, //此乃新增控制
				editChargingVisible: false, //此乃编辑控制
				// number
				dataIndex: 0,
				idx:0,
				CodeNumber:0,
				pageNum: 1, //当前页currentPage
				pageSize: 8,
				totalSize: 10, //总条数
				/* obj */
				// 新增
				addForm: {
				  	coding: "", // 编码
					priceCode:"", // 物价编码
				  	applicableObjects: "", // 适用对象id
					applicableObjectsName: "", // 适用对象
				  	chargeProjectName: "", // 收费项目名称
					simpCode: "", // 拼音简码
				  	description: "", // 规格说明
				  	financialClassId: "", // 财务分类id
					financialClassIdName: "", // 财务分类
				  	measurementUnit: "", // 计量单位
					oneCeilingPrice: "", // 1类最高限价
					twoCeilingPrice: "", // 2类最高限价
					threeCeilingPrice: "", // 3类最高限价
				  	expenseCategoryId: "", // 费用类别id
					expenseCategoryIdName: "", // 费用类别
					medicalRecordCostId:"", //病案费别id
					medicalRecordCostIdName:"", //病案费别
					status:"", // 有效状态id
					statusName:"", // 有效状态
					standardName: "", // 国家贯标名称
					standardCode: "", // 国家贯标编码
					projectConnotation: "", // 项目内涵
				  	excludedContent: "", // 除外内容
					operatingPeople: "", // 操作人
					operatingTime: "", // 操作时间
					remake: "", // 备注
				},
				// 编辑
				editForm: {
				  	coding: "", // 编码
					priceCode:"", // 物价编码
				  	applicableObjects: "", // 适用对象id
					applicableObjectsName: "", // 适用对象
				  	chargeProjectName: "", // 收费项目名称
					simpCode: "", // 拼音简码
				  	description: "", // 规格说明
				  	financialClassId: "", // 财务分类id
					financialClassIdName: "", // 财务分类
				  	measurementUnit: "", // 计量单位
					oneCeilingPrice: "", // 1类最高限价
					twoCeilingPrice: "", // 2类最高限价
					threeCeilingPrice: "", // 3类最高限价
				  	expenseCategoryId: "", // 费用类别id
					expenseCategoryIdName: "", // 费用类别
					medicalRecordCostId:"", //病案费别id
					medicalRecordCostIdName:"", //病案费别
					status:"", // 有效状态id
					statusName:"", // 有效状态
					standardName: "", // 国家贯标名称
					standardCode: "", // 国家贯标编码
					projectConnotation: "", // 项目内涵
				  	excludedContent: "", // 除外内容
					operatingPeople: "", // 操作人
					operatingTime: "", // 操作时间
					remake: "", // 备注
				},
				// arr
				data: [],
				oop:[],
				userInfo: [],
				// 新增表单自定义格式
				formType:[],
				selectChanceAll:[],
				CostIdOptions:[], // 病案费别
				ClassIdOptions:[], // 财务分类
				expenseCategoryIdOptions:[],
				ObjectsOptions:[{ id:1,label:'门诊',value:'门诊'},{ id:2,label:'住院',value:'住院'},{ id:3,label:'门诊和住院',value:'门诊和住院'},{ id:4,label:'打包明细',value:'打包明细'}],
				watchData: [],
				YNuse:[{ id:1,label:'可用',value:'1'},{ id:2,label:'禁用',value:'2'}],
				// title右侧按钮
				headerBtn:[
				 { refesh:"refesh", title:"刷新", type:"", icon:"el-icon-refresh" },
				 { senior:"senior", title:"高级", type:"", icon:"" },
				 { add:"add", title:"新增", type:"warning" },
				],
				// title右侧按钮
				tableRows:[
					{ name:"系统序号", prop:"id", type:"" },{ name:"有效状态", prop:"state", type:"" },
					{ name:"编码", prop:"coding", type:""},{ name:"物价编码", prop:"priceCode", type:"" },
					{ name:"名称", prop:"chargeProjectName", type:"" },{ name:"项目内涵", prop:"projectConnotation", type:"" },
					{ name:"规格说明", prop:"description", type:"" },{ name:"计量单位", prop:"measurementUnit", type:"" },
					{ name:"一级指导单价", prop:"oneCeilingPrice", type:"" },{ name:"二级指导单价", prop:"twoCeilingPrice", type:"" },{ name:"三级指导单价", prop:"threeCeilingPrice", type:"" },
					{ name:"费用类别", prop:"costType", type:"" },{ name:"病案费别", prop:"recordType", type:"" },{ name:"财务分类", prop:"financeClass", type:"" },
					{ name:"适用对象", prop:"applicableObjectsName", type:"" },{ name:"自付比例", prop:"status", type:"" },
					{ name:"内置否", prop:"status", type:"" },{ name:"操作时间", prop:"operatingTime", type:"" },
					{ name:"操作人", prop:"operatingPeople", type:"" },{ name:"备注", prop:"remake", nz:"nz" },
					{ name:"国家贯标名称", prop:"standardName", type:"" },{ name:"国家贯标编码", prop:"standardCode", type:"" },
				],
				elTree:[
					{
						label: '全部',
						path:'',
						title:'',
						icon:'el-icon-news',
						children:[]
					}
				],
				tableData: [
					{ num:'1', code:'01',name:'预防保健科',nz:'否', status: '可用',remark:'' },
					{ num:'2', code:'02',name:'全科医疗科',nz:'否', status: '可用',remark:'' },
					{ num:'3', code:'03',name:'内科',nz:'否', status: '可用',remark:'' },
					{ num:'4', code:'04',name:'消化内科专业',nz:'否', status: '可用',remark:'' },
					{ num:'5', code:'05',name:'神经内科专业',nz:'否', status: '可用',remark:'' },
					{ num:'6', code:'06',name:'心血管内科专业',nz:'否', status: '可用',remark:'' },
				],
				 pickerOptions: {
				  shortcuts: [{
					text: '今天',
					onClick(picker) {
					  picker.$emit('pick', new Date());
					}
				  }, {
					text: '昨天',
					onClick(picker) {
					  const date = new Date();
					  date.setTime(date.getTime() - 3600 * 1000 * 24);
					  picker.$emit('pick', date);
					}
				  }, {
					text: '一周前',
					onClick(picker) {
					  const date = new Date();
					  date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
					  picker.$emit('pick', date);
					}
				  }]
				},
			};
		},
		computed: {
		    // 格式化数字，确保4个0后的数字自增时不会出现前导零
		    formattedNumber() {
				return '00000' + this.toCodeNum.toString().slice(1);
		    },
		  },
		mounted() {
			// 新增表单自定义格式
			this.formType = AccType.map(function(v) {
				return v
			})
			this.editType = editType.map(function(v) {
				return v
			})
			this.loadData();
			//获取动态盒子宽度，实时赋值给右侧 => this.$refs.mainRight.offsetWidth;
			this.$nextTick(()=>{
				this.updateWindowWidth();
				window.addEventListener('resize', this.updateWindowWidth);
			})
			this.dataIndex ++
			this.getAllTree();
			this.nowDateTime();
			
			this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
			this.addForm.operator = this.userInfo.userName

			// 模拟信息
			// this.oop = MedicenCata.map(function(v) {
			// 	return v
			// })
		},
		methods: {
			/*
				about tree
			*/
		    async getAllTree(){
			   let res = await getCostType();
			   this.elTree[0].children.push(...res.data.map(v=>{ return { label: v.name , ...v } }));
			   console.log(this.elTree);
		    },
			handleNodeClick(data,e) {
				this.loading = true;//关闭加载
				this.addForm.expenseCategoryId = data.label
				this.CatalogueName = data.label
				this.iconComes = 'el-icon-' + this.makePy(data.label)
				console.log(data);
				this.loadData();
			},

			/*
				about table
			*/
		   
		   // 数据源 毒麻类型
		    async loadData(){
				let res = await getCostList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					costType: this.CatalogueName,
					chargeProjectName:this.searchValue
				})
				if(res.data){
					setTimeout(() => {
						this.tableData = res.data.content
						this.$message({
						  message: '已为您查询到' + res.data.totalSize + '条数据.',
						  type: 'success'
						});
						this.loading = false;
					}, 1500)
					
				}else{
					setTimeout(() => {
						this.tableData = [];
						this.$message.error(res.message)
						this.loading = false;
					}, 1500)
				}
		    },
		    // col 里面包含了表头字段和名称，list 是表格数据
		    columnWidth(col, list) {
		         let prop = col.prop,lab = col.lab;
		         let width = 80; // 设定一个最小值
		         let maxlenStr = ""; // 最长字符串
		         for (let info of list) {
		           if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
		         }
		         width = Math.max(width, len(lab), len(maxlenStr));
		         // 表格自带的内边距(20px) 自调
		         return width + 22; // 这里加了 12px
		         function len(str) {
		           // 实际分配长度可根据需要自行调整
		           let length = 8;
		           for (const char of str + "") {
		             // 英文小写字符 8px
		             if ("a" <= char && char <= "z") length += 8;
		             // 英文大写字符 8px
		             else if ("A" <= char && char <= "Z") length += 8;
		             // 中文字符 28px
		             else if (char >= "\u4e00" && char <= "\u9fa5") length += 28;
		             // 其他 8px
		             else length += 12;
		           }
		           return length;
		         }
		       },
			// see table
			handleDelete(id){
				this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(async () => {
						let res = await deleteByPoison(id);
						let { code, message } = res;
						if (res.code === 200) {
							this.$message({
								type: "success",
								message: message,
							});
							this.loadData(); //更新数据驱动
						} else {
							this.$message.error(message);
						}
					})
					.catch(() => {
						this.$message({
							type: "fail",
							message: '失败',
						});
					});
			},
			// edit table
			handleClickEdit(row){
				this.editChargingVisible = true;
				this.editForm = { ...row };
			},
			// 编辑保存
			async saveEditData(){
				console.log(this.editForm);
				let rs = await updateChargeProject(this.editForm);
				if (code === 200) {
					this.$message({
						type: 'success',
						message: '修改成功！',
					});
					this.loadData(); //更新驱动
					this.editChargingVisible = false;
				} else {
					this.$message.error('失败！')
				}
			},
			//新增保存
			async addNewData(){
				// let res = await addChargeProject(this.addForm)
				console.log(this.addForm);
				//触发验证表单
				    let res = await addChargeProject(this.addForm)
				    console.log(res);
					if (res.code === 200){
					this.$message({
						message:res.message,
						type:"success"
					});
					this.loadData(); //更新数据驱动
					this.addChargingVisible = false
					}else{
					  //验证失败
					  console.log('失败');
					}
			},
			//  icons聚焦
			OpenIconsFocus(v,i){
				// v.id = i;
				// console.log(v,i);
				// this.idx = i;
				// i event
				switch (i) {
					case 3:
					// 转拼音简码
					this.addForm.simpCode = this.makePy(this.addForm.chargeProjectName);
					this.editForm.simpCode = this.makePy(this.editForm.chargeProjectName);
					// console.log(this.addForm.chargeProjectName)
					break;
				}
			},
			//  select聚焦
			async sname(v,i) {
				this.idx = i
				switch (i) {
					case 3:
					// 调用备注收费项目接口 用于填充
					let result = await standardList();
					this.selectChanceAll = result.data.map(v=>{ return { label: v.chargeProjectName , ...v } })
					break;
					case 6:
					// 调用财务分类接口
					let rs = await getSosTypes();
					this.ClassIdOptions = rs.data.map(v=>{ return { label: v.name , ...v } })
					
					break;
					case 11:
					// 江树菜单列表数据取出
					this.expenseCategoryIdOptions = this.elTree[0].children
					case 12:
					// 调用病案费别接口
					let res = await getMREC();
					this.CostIdOptions = res.data.map(v=>{ return { label: v.name , ...v } })
					// this.CostIdOptions = ...res.data
					break;
				}
			},
			// SelectVal to editForm
			async scname(v){
				switch (this.idx) {
					case 3:
					// 财务分类
					let rs = await getSosTypes();
					this.ClassIdOptions = rs.data.map(v=>{ return { label: v.name , ...v } })
					this.addForm.chargeProjectName = v.label
					// 转拼音简码
					this.addForm.simpCode = this.makePy(this.addForm.chargeProjectName);
					this.addForm.description = v.description
					// 费用类别
					this.addForm.expenseCategoryId = v.expenseCategoryId
					if(v.type != ''){
						this.expenseCategoryIdOptions = this.elTree[0].children
						this.expenseCategoryIdOptions = this.expenseCategoryIdOptions.filter(item=>{ return item.id === v.type })
						this.addForm.expenseCategoryIdName = this.expenseCategoryIdOptions[0].label
					}
					// 病案费别
					this.addForm.medicalRecordCostId = v.medicalRecordCostId
					if(v.medicalRecordCostId != ''){
						// 调用病案费别接口
						let res = await getMREC();
						this.CostIdOptions = res.data.map(v=>{ return { label: v.name , ...v } })
						this.CostIdOptions = this.CostIdOptions.filter(item=>{ return item.id === v.medicalRecordCostId })
						this.addForm.medicalRecordCostIdName = this.CostIdOptions[0].label
					}
					this.addForm.finClassCode = v.finClassCode
					// 财务分类Id
					this.addForm.financialClassId = v.financialClassId
					if(v.financialClassId != ''){
						let abc = this.ClassIdOptions.filter(item=>{ return item.id === v.financialClassId })
						this.addForm.financialClassIdName = abc[0].label
					}
					this.addForm.measurementUnit = v.measurementUnit
					this.addForm.oneCeilingPrice = v.oneCeilingPrice
					this.addForm.priceCode = v.priceCode
					this.addForm.threeCeilingPrice = v.threeCeilingPrice
					this.addForm.twoCeilingPrice = v.twoCeilingPrice
					this.addForm.type = v.type
					this.addForm.applicableObjects = v.applicableObjects
					 = v.applicableObjects
					if(this.addForm.applicableObjects == 0){
						this.addForm.applicableObjectsName = '全部'
					}else if(this.addForm.applicableObjects == 1){
						this.addForm.applicableObjectsName = '门诊'
					}else if(this.addForm.applicableObjects == 2){
						this.addForm.applicableObjectsName = '住院'
					}else if(this.addForm.applicableObjects == 3){
						this.addForm.applicableObjectsName = '门诊和住院'
					}else{
						this.addForm.applicableObjectsName = '打包明细'
					}
					break;
					case 2:
					this.addForm.applicableObjects = v.id
					this.addForm.applicableObjectsName = v.label
					console.log(this.addForm.applicableObjects)
					break;
					case 6:
					this.addForm.financialClassId = v.id
					this.addForm.financialClassIdName = v.label
					break;
					case 11:
					this.addForm.expenseCategoryId = v.id
					this.addForm.expenseCategoryIdName = v.label
					break;
					case 12:
					this.addForm.medicalRecordCostId = v.id
					this.addForm.medicalRecordCostIdName = v.label
					break;
					case 13:
					this.addForm.status = v.id
					this.addForm.statusName = v.label
					break;
				}
				// this.addForm.status = v.value
				
			},
			// input 
			inputLabel(){
				this.addForm.code = this.makePy(this.addForm.label).toLocaleUpperCase().slice(0,1) + this.formattedNumber + this.CodeNumber;//编码
				this.addForm.textSpell = this.makePy(this.addForm.label).toLocaleUpperCase();//拼音简码
			},
			handleClose(done) {
				this.$confirm('确认关闭？')
				  .then(_ => {
					this.formdisabled = true;
					done();
				  })
				  .catch(_ => {
					this.formdisabled = this.formdisabled;
				  });
			},
			// db events
			handledbRow(row, column, event){
				if(row){ this.form = row; this.dialogVisible = true } else { console.log('fail'); }
				// console.log(this.form);
				this.formdisabled = true
				this.form.textSpell = this.makePy(this.form.label).toLocaleUpperCase()
				// console.log(this.form.textSpell);
			},

			// 步骤
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// 处理索引0的逻辑
						this.loading = true;
						if(this.searchValue == ''){
							setTimeout(() => {
								this.$message.error('关键字不能为空！');
								this.loading = false;		
							}, 1500)
						}else{
							this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						}
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
					case 2:
						// 处理索引2的逻辑 => 新增
						this.addChargingVisible = true
						break;
				}
			},
			handleCommand(command) {
			  // console.log(command);
			  // 根据 command 值执行相应的逻辑
			  switch (command) {
				case 'a':
				  // 处理a的逻辑
				  console.log('执行A逻辑');
				  this.DropDownedName = '可用'
				  break;
				case 'b':
				  // 处理b的逻辑
				  console.log('执行B逻辑');
				  this.DropDownedName = '禁用'
				  break;
				case 'c':
				  // 处理b的逻辑
				  this.DropDownedName = '全部'
				  break;
				// ... 其他 case
			  }
			},
			//分页
			//每页条数改变触发
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.pageNum = val;
			},
			//当前条数改变触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageNum = val;
			},
			// 实时宽度
			updateWindowWidth() {
			    this.windowWidth = window.innerWidth - 368;
			},
			// 系统当前日期时间
			nowDateTime(){
				const now = new Date(); //创建时间日期对象
				const year = now.getFullYear(); //年
				const month = now.getMonth() + 1; //月份是从0开始的
				const day = now.getDate(); //日
				const hours = now.getHours(); //小时
				const minutes = now.getMinutes(); //分钟
				const seconds = now.getSeconds(); //秒
				const currentDate = `${year}-${month}-${day}`.replace(/-/g, '') //替换操作
				this.nowDateTimeValue = `${year}-${month}-${day}` + ` ` + `${hours}:${minutes}:${seconds}`
				// this.datetimesinglend = 
				// 将字符串转换为Date对象
				// console.log(this.nowDateTimeValue);
			}
			
		}
	}
</script>

<style lang="less" scoped>
	// 穿透
	/deep/ .el-dialog__header{
		padding: 12px;
		background-color: #007bb0;
	}
	/deep/ .el-dialog__title{
		font-size: 12px;
		color: #fff;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close{
		color: #fff;
	}
	/deep/ .el-input.is-disabled .el-input__inner{
		color: #87898f;
	}
	/deep/ .el-textarea.is-disabled .el-textarea__inner{
		color: #87898f;
	}
	/deep/ .el-icon-arrow-left:before {
	    content: "\e67d";
	    font-size: 18px;
	}
	/deep/ .el-dropdown-menu__item{
		font-size: 12px;
	}
	/deep/ .el-dialog__body{
		padding: 12px;
	}
	/deep/ .el-descriptions{
		font-size: 12px !important;
	}
	/deep/ .el-descriptions-item__container{
		display: flex !important;
		// align-items: center !important;
		padding-top: 12px !important;
	}
	/deep/ .el-descriptions-item__label:not(.is-bordered-label){
		padding-left: 0;
		display: flex;
		justify-content: right;
	}
	/deep/ .el-color-picker__icon, .el-input, .el-textarea{
		width: 100%;
	}
	/deep/ .el-pagination{
		padding: 6px;
	}
	// content
	.MedicenCata {
		height: 100%;
		width: 100%;
		// header
		.header {
			display: flex;
			flex-direction: row;
			align-items: center;
			height: 40px;
			background-color: #efefef;
			padding: 4px;

			// justify-content: space-evenly;
			// icon
			.header-icon {
				display: flex;
				align-items: center;
			}

		}

		// main
		.main {
			width: 100%;
			display: flex;
			justify-content: space-between;
			// height: 473px; /* 设置父容器的高度 */
			// overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
			// left
			.main-left {
				.custom-tree {
				  max-height: 100%; /* 设置树形菜单的最大高度为父容器的100% */
				  overflow-y: auto; /* 当内容超出设定高度时显示滚动条 */
				}
				/deep/ .el-tree-node__content {
					// height: 40px;
					// padding-right: 8px !important;
				}
				/deep/ .el-tree-node__label{
					font-size: 12px;
				}
				width: 128px;
				height: 100%;
			}

			// right
			.main-right {
				flex: 4;
				height: 100%;
				// alert
				.addmessagesBox{
					.tabs{
						/deep/ .el-select>.el-input{
							width: 172px;
						}
						/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
							width: 172px;
						}
						/deep/ .el-form-item__content{
							display: flex;
							
							span{
								font-size: 12px;
							}
						}
						.oneLine{
							width: 524px;
							// background-color: indianred;
						}
					}
					/deep/ .el-dialog__title{
						font-size: 12px;
					}
					/deep/ .el-table{
						font-size: 12px;
					}

				}
				// icon
				.main-icon {
					display: flex;
					align-items: center;
					padding: 12px;
					line-height: 40px;
					.main-icon-a{
						// width: 240px;
						// background-color: #00557f;
					}
					.main-icon-b{
						margin-left: 28px;
						/deep/ .el-dropdown{
							font-size: 12px;
							cursor: pointer;
						}
						/deep/ .el-dropdown:hover {
							font-weight: bold;
							color: #66b1ff;
						}
						/deep/ .el-icon--right{
							// background-color: #66b1ff;
						}
						/deep/ .el-popper[x-placement^=bottom]{
							margin-top: 0;
						}
					}
					// c
					.main-icon-c{
						display: flex;
						margin-left: 28px;
						/deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b]{
							width: 80%;
						}
					}
				}
				// table
				/deep/ .el-table .cell{
					font-size: 12px;
					text-align: center;
				}

				/deep/ .el-table td.el-table__cell div :first-child{
					text-align: center;
				}
				/deep/ .el-table td.el-table__cell div{
					text-align: left;
					overflow: hidden;
					white-space: normal;
					word-break: break-all;
				}
				
				.table{
					
				}
			}
		}

		// feet
		.feet {
			.addmessagesBox{
				.aform{
					padding: 12px;
					margin-top: 12px;
					border: 1px solid #e7e7e7;
				}
				.bform{
					padding: 12px;
					margin-top: 12px;
					border: 1px solid #e7e7e7;
				}
			}
			// alert
			.messagesBox{
				.tabs{
					
					/deep/ .el-form-item__content{
						display: flex;
						
						span{
							font-size: 12px;
						}
					}
					.oneLine{
						width: 524px;
						// background-color: indianred;
					}
				}
				/deep/ .el-dialog__title{
					font-size: 12px;
				}
				/deep/ .el-table{
					font-size: 12px;
				}
				
			}
		}

	}
</style>